import {
  GET_CAMPAIGN_TYPE,
  GET_CAMPAIGN_TYPE_FAILURE,
  GET_CAMPAIGN_TYPE_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCampaignTypeReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_TYPE:
      return { ...state, loading: true };
    case GET_CAMPAIGN_TYPE_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_CAMPAIGN_TYPE_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCampaignTypeReducer;
